var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrontierIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "circle-nodes",
    d: "M50,8.333a8.333,8.333,0,0,0-16.667,0c0,.14.035.271.042.408L15.387,14.362a8.331,8.331,0,1,0-2.525,11.365l13.146,12.05A8.22,8.22,0,0,0,25,41.667a8.333,8.333,0,1,0,12.3-7.283L41.731,16.66A8.339,8.339,0,0,0,50,8.333ZM34.612,12.721a8.359,8.359,0,0,0,3.088,2.9L33.271,33.342a8.286,8.286,0,0,0-4.465,1.348L15.66,22.64a8.22,8.22,0,0,0,1.008-3.89c0-.14-.035-.271-.042-.408l17.988-5.621Z",
    fill: "#3db6fb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontierIcon);
export default __webpack_public_path__ + "static/media/frontier_icon.dc4e14054047efa54217ef640c5b65c7.svg";
export { ForwardRef as ReactComponent };